import React from 'react'
import PropTypes from 'prop-types'
import ZeroKmFlag from '@/modern/components/Stamps/ZeroKm'
import { Price, InfoArea, Card } from '@/modern/components/Card'
import ImageCard from '../../Card/ImageCard'
import { Item, ZeroStripes, Informations } from './style'
import { Text, Link, LinkWithGrow, FlagContainer } from '../style'

const VehicleDetailsVertical = props => {
  const { name, version, price, year, href = '#', image, experience } = props
  const linkProps = { rel: 'nofollow', target: '_blank', href }

  return (
    <Card>
      <LinkWithGrow {...linkProps}>
        <FlagContainer>
          <ZeroKmFlag />
        </FlagContainer>
        <ImageCard>
          <img src={image} alt="zero" />
        </ImageCard>

        <InfoArea background="linear-gradient(180deg, rgba(255, 255, 255, 0) 9.32%, #ECEDF2 100%);">
          <Informations>
            <Item margin={experience === 'PRICE' ? '0px' : '0px 0px 60px'}>
              <Text size={12} color="#2E2D37" uppercase>
                {name}
              </Text>
              <Text size={12} uppercase>
                {version}
              </Text>
            </Item>
            {experience === 'PRICE' && (
              <Item margin="17px 0px 2px">
                <Text size={8}>preço sugerido</Text>
                <Price value={`00, ${price}`} />
              </Item>
            )}
            <Item display="flex" justify="space-between">
              <Text size={12} color="#696977">{`2021/${year}`}</Text>
              <Text size={12} color="#696977">
                0km
              </Text>
            </Item>
            <ZeroStripes />
          </Informations>
        </InfoArea>
      </LinkWithGrow>
    </Card>
  )
}

VehicleDetailsVertical.defaultProps = {
  name: null,
  version: null,
  price: null,
  year: null,
  href: '#',
  experience: null,
  image: null,
}

VehicleDetailsVertical.propTypes = {
  name: PropTypes.string,
  version: PropTypes.string,
  price: PropTypes.string,
  year: PropTypes.string,
  href: PropTypes.string,
  image: PropTypes.string,
  experience: PropTypes.string,
}

export default VehicleDetailsVertical
